export default __webpack_public_path__ + "assets/app-store-button-white.1d412519.png";